import React from 'react';
import { Login } from '../../containers/Login'


const LoginPage = () => <Login></Login>;

export { LoginPage };